export default __webpack_public_path__ + "static/media/CNo.57-1.b326ed25.jpg";